export default __webpack_public_path__ + "static/media/working-with-us-tablet.a4f9cd3e.jpg";